<template>
	<div class="user-center-container">
		<div class="user-center-header filter-container">
			<!-- 搜索条件区域 -->
			<div class="search-container">
				<div class="search-form">
					<div class="form-item">
						<span class="label">订单编号</span>
						<el-input v-model="queryParams.orderCode" placeholder="请输入订单编号" clearable></el-input>
					</div>
					<div class="form-item">
						<span class="label">订单类型</span>
						<el-select v-model="queryParams.orderType" placeholder="请选择订单状态" clearable>
							<el-option v-for="item in orderTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</div>
					<div class="form-item">
						<span class="label">支付状态</span>
						<el-select v-model="queryParams.orderState" placeholder="请选择支付状态" clearable>
							<el-option v-for="item in orderStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</div>
					<div class="form-buttons">
						<el-button type="primary" @click="handleSearch">查询</el-button>
						<el-button @click="handleResetSearch">重置</el-button>
					</div>
				</div>
			</div>
		</div>

		<div class="user-center-content">
			<div v-if="orderList.length" class="btn-group">
				<el-button type="primary" plain @click="handleApplyInoice">
					申请开票
				</el-button>
			</div>

			<!-- 订单列表 -->
			<div v-loading="loading" class="order-list">
				<template v-if="orderList.length">
					<div v-for="(order, index) in orderList" :key="index" class="order-item">
						<div class="order-header">
							<div class="order-info">
								<span class="order-no">订单号：{{ order.orderCode }}</span>
								<span class="order-time">下单时间：{{ order.createTime }}</span>
								<span v-if="order.payTime" class="order-time">支付时间：{{ order.payTime }}</span>
							</div>
							<div class="order-status" :class="getOrderStateClass(order.orderState)">
								{{ getOrderStateName(order.orderState) }}
							</div>
						</div>

						<div class="order-content">
							<div class="product-info">
								<!-- <img :src="order.productImage" alt="商品图片" class="product-image" /> -->
								<div class="product-detail">
									<div class="product-name">{{ order.setMealName }}</div>
									<div class="product-desc">{{ order.eventName }}</div>
								</div>
							</div>
							<div class="price-info">
								<div class="amount">￥{{ order.actualPayment }}</div>
							</div>
						</div>

						<div v-if="isOrderUnpaid(order.orderState)" class="order-footer">
							<el-button v-if="isOrderUnpaid(order.orderState)" type="primary" @click="handleOpenPayVouchaer(order)">
								立即付款
							</el-button>
							<el-button v-if="isOrderUnpaid(order.orderState)" type="warning" @click="handleResetPackage(order)">
								重新选择套餐
							</el-button>
							<el-button v-if="isOrderUnpaid(order.orderState)" @click="handleCancelOrder(order)">取消订单</el-button>
						</div>
					</div>
				</template>

				<!-- 数据为空 -->
				<empty-content v-else empty-text="暂无订单信息"></empty-content>

				<!-- 分页 -->
				<div v-if="pageOptions.total > pageOptions.limit" class="pagination-container">
					<jr-pagination
						:limit="pageOptions.limit"
						:page.sync="pageOptions.page"
						:total="pageOptions.total"
						layout="prev, pager, next"
						prev-text="上一页"
						next-text="下一页"
						@change="handlePaginationChange"
					></jr-pagination>
				</div>
			</div>
		</div>

		<!-- 购买会员弹窗 -->
		<jr-dialog :visible.sync="payVisible" width="840px" :show-btn="false" @close="handleCancel">
			<template slot="title">
				<!-- 自定义弹窗标题 -->
				<h4 class="model-title">
					<span>购买会员</span>
				</h4>
			</template>
			<template slot="content">
				<payment-dialog :old-order-id="oldOrderId" @payOrderSuccess="handlePayOrderSuccessCallback"></payment-dialog>
			</template>
		</jr-dialog>

		<!-- 上传付款凭证弹窗 -->
		<jr-dialog :visible.sync="payVoucherVisible" width="1400px" :show-btn="false" @close="handlePayClose">
			<template slot="title">
				<!-- 自定义弹窗标题 -->
				<h4 class="model-title">
					<span>上传付款凭证</span>
				</h4>
			</template>
			<template slot="content">
				<upload-pay-voucher
					v-if="payVoucherVisible"
					:order-id="curPayOrderId"
					:order-number="curPayOrderNumber"
					@uploadSuccess="handlePaySuccessCallback"
					@uploadCancel="handlePayClose"
				></upload-pay-voucher>
			</template>
		</jr-dialog>
	</div>
</template>

<script>
	import JrDialog from '@/components/Dialog'
	import JrPagination from '@/components/Pagination'
	import PaymentDialog from '@/views/memberBenefits/paymentDialog.vue'
	import UploadPayVoucher from './components/uploadPayVoucher.vue'
	import { queryOrderRecord, cancelOrder } from '@/api/memberBenefit/index'
	import { ENUM_ORDER_STATE, ORDER_STATE, ORDER_STATE_CLASS, ENUM_ORDER_TYPE } from '@/enum/index'

	// 我的订单
	export default {
		name: 'OrderList',
		components: {
			JrDialog,
			JrPagination,
			PaymentDialog,
			UploadPayVoucher
		},
		props: {},
		data() {
			return {
				// 查询参数
				queryParams: {
					orderCode: '',
					orderType: '',
					orderState: ''
				},
				// 分页配置
				pageOptions: {
					limit: 3,
					page: 1,
					total: 0
				},
				// 加载状态
				loading: false,
				// 订单类型选项
				orderTypes: [],
				// 订单状态选项
				orderStatus: [],
				// 订单列表数据
				orderList: [],

				// 购买会员弹窗
				payVisible: false,
				oldOrderId: '',
				// 上传打款证明弹窗
				payVoucherVisible: false,
				// 当前需付款的订单id
				curPayOrderId: '',
				// 当前需要付款的订单编号
				curPayOrderNumber: ''
			}
		},
		computed: {},
		watch: {},
		created() {
			// 将ENUM_ORDER_TYPE转给orderTypes
			this.orderTypes = Object.keys(ENUM_ORDER_TYPE).map(key => ({
				label: ENUM_ORDER_TYPE[key],
				value: key
			}))

			// 将ENUM_ORDER_STATE转给orderStatus
			this.orderStatus = Object.keys(ENUM_ORDER_STATE).map(key => ({
				label: ENUM_ORDER_STATE[key],
				value: Number(key)
			}))
		},
		mounted() {
			this.handleGetMyOrderList()
		},
		methods: {
			// 获取订单状态名称
			getOrderStateName(state) {
				return ENUM_ORDER_STATE[state] || '未知状态'
			},

			// 获取订单状态对应的CSS类名
			getOrderStateClass(state) {
				return ORDER_STATE_CLASS[state] || ''
			},

			// 判断订单是否为待支付状态
			isOrderUnpaid(state) {
				return Number(state) === ORDER_STATE.UNPAID
			},

			// 判断订单是否为已支付状态
			isOrderPaid(state) {
				return Number(state) === ORDER_STATE.PAID
			},

			// 判断订单是否为已取消状态
			isOrderCancelled(state) {
				return Number(state) === ORDER_STATE.CANCELLED
			},

			// 判断订单是否为已作废状态
			isOrderAbolish(state) {
				return Number(state) === ORDER_STATE.ABOLISH
			},

			// 判断订单是否为待审核状态
			isOrderWaitAudit(state) {
				return Number(state) === ORDER_STATE.WAITAUDIT
			},

			// 查询我的订单
			handleGetMyOrderList() {
				this.loading = true

				const params = {
					page: this.pageOptions.page,
					size: this.pageOptions.limit,
					...this.queryParams
				}

				queryOrderRecord(params)
					.then(response => {
						const { data } = response
						if (data.records && data.records.length > 0) {
							this.orderList = data.records || []
							this.pageOptions.total = data.total || 0
						} else {
							this.orderList = []
							this.pageOptions.total = 0
						}
						this.loading = false
					})
					.catch(() => {
						this.loading = false
						this.orderList = []
						this.pageOptions.total = 0
					})
			},

			// 分页
			handlePaginationChange(pager) {
				const { page, limit } = pager
				this.pageOptions.page = page
				this.pageOptions.limit = limit
				this.handleGetMyOrderList()
			},

			// 搜索
			handleSearch() {
				this.pageOptions.page = 1
				this.pageOptions.limit = 3
				this.handleGetMyOrderList()
			},

			// 重置搜索
			handleResetSearch() {
				this.queryParams = {
					orderCode: '',
					orderType: '',
					orderState: ''
				}
				this.handleGetMyOrderList()
			},

			// 订单创建成功回调
			handlePayOrderSuccessCallback() {
				console.log('订单创建成功回调')

				this.payVisible = false
			},

			// 重新选择套餐
			handleResetPackage(order) {
				this.oldOrderId = order.id
				this.payVisible = true
				console.log(this.oldOrderId, 'this.oldOrderId')
			},
			handleCancel() {
				this.oldOrderId = ''
				this.payVisible = false
				console.log(this.oldOrderId, 'this.oldOrderId')
			},

			// 取消订单
			handleCancelOrder(order) {
				const data = {
					orderId: order.id
				}

				this.$modal
					.confirm('请确认是否取消该订单？')
					.then(() => {
						return cancelOrder(data)
					})
					.then(() => {
						this.$modal.msgSuccess('订单取消成功')
						this.handleGetMyOrderList()
					})
					.catch(() => {})
			},

			// 申请开票
			handleApplyInoice() {
				this.$router.push({
					path: '/user/market/order/select'
				})
			},

			// 打开上传打款证明弹窗
			handleOpenPayVouchaer(order) {
				this.curPayOrderId = order.id
				this.curPayOrderNumber = order.orderCode
				this.payVoucherVisible = true
			},

			// 关闭上传打款证明弹窗
			handlePayClose() {
				this.curPayOrderId = ''
				this.curPayOrderNumber = ''
				this.payVoucherVisible = false
			},

			// 上传打款证明成功回调
			handlePaySuccessCallback() {
				this.curPayOrderId = ''
				this.curPayOrderNumber = ''
				this.payVoucherVisible = false
				this.handleGetMyOrderList()
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/views/user/styles/user-center.scss';

	.order-list {
		.order-item {
			background: #fff;
			border-radius: 8px;
			margin-bottom: 20px;
			transition: all 0.3s ease;
			border: 1px solid #ebeef5;
			opacity: 0;
			transform: translateY(20px);
			animation: slideUp 0.5s ease forwards;

			@keyframes slideUp {
				to {
					opacity: 1;
					transform: translateY(0);
				}
			}

			&:hover {
				box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
				transform: translateY(-2px);
			}

			.order-header {
				padding: 10px 20px;
				border-bottom: 1px solid #ebeef5;
				background: #fafafa;
				border-radius: 8px 8px 0 0;
				display: flex;
				justify-content: space-between;
				align-items: center;

				.order-info {
					.order-no {
						font-size: 15px;
						font-weight: 500;
						margin-right: 30px;
					}

					.order-time {
						color: #909399;
						font-size: 14px;

						& + .order-time {
							margin-left: 30px;
						}
					}
				}

				.order-status {
					padding: 4px 12px;
					border-radius: 15px;
					font-size: 14px;

					&.unpaid {
						color: #e6a23c;
						background: #fdf6ec;
					}

					&.success {
						color: #67c23a;
						background: #f0f9eb;
					}

					&.cancelled {
						color: #909399;
						background: #f4f4f5;
					}

					&.abolish {
						color: #f56c6c;
						background: #fef0f0;
					}

					&.waitaudit {
						color: #e6a23c;
						background: #fdf6ec;
					}
				}
			}

			.order-content {
				padding: 15px 20px;

				.product-info {
					.product-detail {
						.product-name {
							font-size: 16px;
							color: #303133;
							margin-bottom: 10px;
							font-weight: 500;
							transition: color 0.3s;

							&:hover {
								color: #1374eb;
							}
						}

						.product-desc {
							color: #909399;
							font-size: 14px;
							line-height: 1.6;
						}
					}
				}

				.price-info {
					.amount {
						color: #f56c6c;
						font-size: 22px;
						font-weight: 500;

						// &::before {
						// 	content: '¥';
						// 	font-size: 16px;
						// 	margin-right: 2px;
						// }
					}
				}
			}

			.order-footer {
				padding: 10px 20px;
				border-top: 1px solid #ebeef5;
				text-align: right;
				background: #fafafa;
				border-radius: 0 0 8px 8px;

				.el-button {
					padding: 9px 20px;
					transition: all 0.3s;

					&:hover {
						transform: translateY(-1px);
					}

					& + .el-button {
						margin-left: 12px;
					}
				}
			}
		}
	}
</style>
